import { Link } from "react-router-dom";
import { Province } from "../types/canvasTypes";

interface HomeLinkProps {
  province: Province;
}

const HomeLink = ({ province }: HomeLinkProps) => {
  return (
    <Link to="/">
      <button className="edit-button" style={{ marginTop: "20px" }}>
        {province === Province.Ontario ? "Home" : "Accueil"}
      </button>
    </Link>
  );
};

export default HomeLink;
